import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as m } from "react";
const n = ({
  title: e,
  titleId: o,
  ...i
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...i,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m321.463 854.308 409.493-409.472-164.843-164.864-409.536 409.515a24.69 24.69 0 0 0-7.232 17.856l1.963 127.445c.213 13.312 10.923 24.064 24.235 24.32l127.979 2.453a24.698 24.698 0 0 0 17.941-7.253m437.251-437.239 96.619-96.619c8.341-8.341 8.341-21.845 0-30.187L720.656 155.586c-8.341-8.32-21.845-8.32-30.165 0l-96.64 96.619 164.864 164.864z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = m(n);
export {
  t as default
};
